/** FlexHR chart tokens — navy #1d3445 / teal #1da193 / Open Sans */

export const CHART_COLORS = {
  teal: "#1da193",
  tealSoft: "#3bb5a8",
  navy: "#1d3445",
  yellow: "#FCC94A",
  red: "#ea3943",
  blue: "#2e5d9e",
  blueSoft: "#5b8ff9",
};

/**
 * Theme for Recharts. Prefer CSS variables so `.analytics-page.dark`
 * and Redux `isDarkMode` stay in sync for visual QA.
 */
export function getChartTheme(isDarkMode) {
  const tick = "var(--analytics-chart-tick)";
  const axis = "var(--analytics-chart-axis)";
  const grid = "var(--analytics-grid)";
  const tooltipBg = "var(--analytics-card-bg)";
  const tooltipBorder = "var(--analytics-card-border)";
  const tooltipText = "var(--analytics-text)";

  return {
    isDarkMode,
    tick,
    axis,
    grid,
    tooltipBg,
    tooltipBorder,
    tooltipText,
    tickProps: {
      fill: tick,
      fontSize: 11,
      fontFamily: '"Open Sans", sans-serif',
    },
    axisLine: { stroke: axis },
    tickLine: { stroke: axis },
    cartesianProps: {
      stroke: grid,
      strokeDasharray: "4 4",
      vertical: false,
    },
    tooltipContentStyle: {
      background: tooltipBg,
      border: `1px solid ${tooltipBorder}`,
      borderRadius: 8,
      boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
      fontFamily: '"Open Sans", sans-serif',
      fontSize: 12,
      color: tooltipText,
      padding: "8px 12px",
    },
    tooltipLabelStyle: {
      color: tooltipText,
      fontWeight: 600,
      marginBottom: 4,
    },
    tooltipItemStyle: { color: tooltipText },
    legendProps: {
      wrapperStyle: {
        fontFamily: '"Open Sans", sans-serif',
        fontSize: 12,
        color: "var(--analytics-muted)",
        paddingTop: 8,
      },
    },
    pieStroke: "var(--analytics-card-bg)",
    cursorFill: isDarkMode
      ? "rgba(255,255,255,0.04)"
      : "rgba(29,52,69,0.04)",
  };
}

/** Shorten long category labels for Y-axis. */
export function shortLabel(name, max = 18) {
  const s = String(name || "");
  if (s.length <= max) return s;
  return `${s.slice(0, max - 1)}…`;
}
